var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { icons, ReportsPageAFY, sizesIcon, variantsAvatar, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { Title } from "../../components/layout/style";
import { dataChip, getFilteredDataCard, optionList } from "./reportPageDTO";
import LocalStorageService from "../../services/localStorage";
import { findParamInLocalStorage } from "../../utils/getAnyDataLocalStorge";
var lsLogin = new LocalStorageService("login");
export var ReportView = function (props) {
    var company = findParamInLocalStorage("subdomain");
    return (_jsxs(React.Fragment, { children: [_jsx(Title, { children: props.t("salesReport.title") }), _jsx("div", __assign({ style: { minHeight: "calc(100vh - 137px)" } }, { children: _jsx(ReportsPageAFY, { avatarVariant: variantsAvatar.rounded, iconAvatar: icons.Search, iconSearch: icons.Search, sizeIcon: sizesIcon.standard, sizesIconSearch: sizesIcon.standard, 
                    // titleClearButton="Limpiar filtros"
                    titleChart: props.t("salesReport.barChart.title"), yAxisTitleChart: props.t("salesReport.barChart.yAxisTitle"), iconBgColor: "#F6F7FB", iconColor: "#3A56A1", iconColorSearch: "#3A56A1", backgroundColorSearch: "#F6F7FB", bgChipSelected: "#EBEEF6", bgChips: "#fff", onClickActionButton: props.openReport, onClickChip: props.onClickOptionChips, onCloseCalendar: props.closeCalendar, onChangeData: props.filterCalendar, dataChips: dataChip, data: getFilteredDataCard(company !== null && company !== void 0 ? company : ""), optionList: optionList, downData: props.newDownData, series: props.dataSeries, categories: props.dataCategories, heightChart: "323px" }) }))] }));
};
